/**
 * The board's head, in words — over the board itself (`PlanningScreen`) and
 * over its page for a Vorgang without a Stand (`CaseRoute`, round-4 screen
 * check R4-3). A module of its own so that page does not load the board.
 */
export const PLANNING_TITLE = "Roste planen";
export const PLANNING_LEDE = "Roste an die Fassade legen. Konsolen und Mengenliste rechnen wir.";
